import {
    ServiceCostBillVerificationModal,
    type ServiceCostBillVerificationValues
} from "../../ServiceCostBillVerificationModal";

export interface VerificationDialogProps {
    open: boolean;
    amount?: number;
    loading?: boolean;
    disabled?: boolean;
    onCancel: () => void;
    onVerification: (values: ServiceCostBillVerificationValues) => void;
}

/** 账户账单核销弹窗，保留旧 Vue 的 visible、amount 和 verification 事件语义。 */
export default function VerificationDialog({
    open,
    amount,
    loading,
    disabled,
    onCancel,
    onVerification
}: VerificationDialogProps) {
    return (
        <ServiceCostBillVerificationModal
            open={open}
            billAmount={amount}
            loading={loading}
            disabled={disabled}
            onCancel={onCancel}
            onSubmit={onVerification}
        />
    );
}
